import { parseEditorLink } from "./editor-links";

const URL_PARSE_BASE = "https://turbonotes.invalid/";

function escapeMarkdownLabel(label: string): string {
  return label.replace(/([\\[\]])/g, "\\$1");
}

function escapeMarkdownDestination(destination: string): string {
  return destination
    .replace(/\\/g, "%5C")
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29");
}

/**
 * Build a Markdown link for a clipboard value that contains exactly one web URL. The
 * selected text is its label, or "here" when nothing is selected, ready to type over.
 */
export function markdownForUrlPaste(
  pastedText: string,
  selectedText: string,
): string | null {
  const source = pastedText.trim();
  if (!source || /\s/.test(source) || /\r|\n/.test(selectedText)) return null;

  const parsed = parseEditorLink(source, URL_PARSE_BASE);
  if (!parsed || parsed.kind !== "url") return null;

  // Replacing an existing link or URL should be a literal replacement, not a nested link.
  if (selectedText && parseEditorLink(selectedText.trim(), URL_PARSE_BASE)) return null;

  const label = selectedText || "here";
  return `[${escapeMarkdownLabel(label)}](${escapeMarkdownDestination(parsed.url)})`;
}
